import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import { BUILD_LABEL } from "./lib/build.js";
console.info(`[spacecrew] ${BUILD_LABEL}`);

const app = mount(App, { target: document.getElementById("app")! });
export default app;
